
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/page/[page]/[product]",
      function () {
        return require("private-next-pages/blog/page/[page]/[product].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/page/[page]/[product]"])
      });
    }
  